import { Component, Injector } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { StringUtils } from '@shared/helpers/StringUtils';
import { PagedListingComponentBase, PagedRequestDto } from '@shared/paged-listing-component-base';
import { CustoAdicionalMensalDto, CustoAdicionalMensalServiceProxy } from '@shared/service-proxies/service-proxies';
import * as moment from 'moment';

export class PagedCustoRequestDto extends PagedRequestDto {
  public dataInicio: moment.Moment;
  public dataFim: moment.Moment;
  public userId: number;
}

@Component({
  selector: 'app-historico-cobranca-custo-adicional',
  templateUrl: './historico-cobranca-custo-adicional.component.html',
  styleUrls: ['./historico-cobranca-custo-adicional.component.scss']
})
export class HistoricoCobrancaCustoAdicionalComponent extends PagedListingComponentBase<CustoAdicionalMensalDto> {

  protected request: PagedCustoRequestDto = new PagedCustoRequestDto();
  protected custosAdicionais: CustoAdicionalMensalDto[] = [];
  public dataInicio: string = "";
  public dataFinal: string = "";

  constructor(
    injector: Injector,
    private readonly _custoAdicionalService: CustoAdicionalMensalServiceProxy
  ) {
    super(injector)
  }

  protected list(request: PagedCustoRequestDto, pageNumber: number, finishedCallback: Function): void {
    request.userId = this.appSession.userId;
    request.dataFim = StringUtils.isNullOrEmpty(this.dataFinal) ? null : moment(this.dataFinal);
    request.dataInicio = StringUtils.isNullOrEmpty(this.dataInicio) ? null : moment(this.dataInicio);

    abp.ui.setBusy();
    this._custoAdicionalService.getAll(
      request.dataInicio,
      request.dataFim,
      request.userId,
      request.skipCount,
      request.maxResultCount
    ).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.custosAdicionais = result.items;
      this.totalItems = result.totalCount;
      this.showPaging(result, pageNumber);
    });
  }

  protected delete(entity: CustoAdicionalMensalDto): void {
    return;
  }

  protected onDateChange(): void {
    this.refresh();
  }

  protected limparFiltro(): void {
    this.request.dataFim = null;
    this.request.dataInicio = null;
    this.dataFinal = null;
    this.dataInicio = null;
    this.refresh();
  }

  protected getStatus(custo: CustoAdicionalMensalDto) {
    switch (custo.status) {
      case 'pending':
        return 'Pendente';
      case 'approved':
        return 'Aprovada';
      case 'authorized':
        return 'Autorizada';
      case 'in_process':
        return 'Em Processamento';
      case 'in_mediation':
        return 'Em Mediação';
      case 'rejected':
        return 'Rejeitada';
      case 'cancelled':
        return 'Cancelada';
      case 'refunded':
        return 'Devolvida';
      case 'charged_back':
        return 'Cobrado de Volta';
      default: return "-"
    }
  }
}
